var _excluded = ["svgRef"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #610b0d;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        font-family: Arial-BoldMT, Arial;\n        font-size: 63.82px;\n        font-weight: 700;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "119.5 0 179.25 76.44 239 152.88 119.5 152.88 0 152.88 59.75 76.44 119.5 0"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  className: "cls-2",
  transform: "translate(94.05 121.41) scale(1.2 1)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "X"));

var SvgRfm = function SvgRfm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 239 152.88",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRfm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rfm.b8789611.svg";
export { ForwardRef as ReactComponent };